package pt.at.oss.kotlin.manual.enumeration

/**
 * Created by Pedro Alfaiate on 14/05/2020.
 */
object FieldSizeConstants {
    // VAT ID number and National Tax number
    // ECOM-OSS-TS-v2.03 - Table 10
    val ISSUING_COUNTRY_LEN: Long = 2
    val VAT_ID_NUMBER_MIN_LEN: Long = 1
    val VAT_ID_NUMBER_MAX_LEN: Long = 12
    val TAX_REF_NUM_MIN_LEN: Long = 1
    val TAX_REF_NUM_MAX_LEN: Long = 50

    // Company name
    val COMPANY_NAME_MIN_LEN: Long = 1
    val COMPANY_NAME_MAX_LEN: Long = 160 // From data model

    // Trading names
    val TRADING_NAME_MIN_LEN: Long = 1
    val TRADING_NAME_MAX_LEN: Long = 250 // From data model

    // Address
    // Limits from data model
    val ADDRESS_FREE_TEXT_MAX_LEN: Long = 250 // N_MORADA_LIVRE
    val ADDRESS_STREET_MAX_LEN: Long = 100 // N_RUA
    val ADDRESS_BUILDING_NUMBER_MAX_LEN: Long = 50 // N_EDIFICIO
    val ADDRESS_FLOOR_NUMBER_MAX_LEN: Long = 64 // X_ANDAR
    val ADDRESS_POST_CODE_MAX_LEN: Long = 50 // X_CODIGO_POSTAL
    val ADDRESS_CITY_MAX_LEN: Long = 100 // N_LOCALIDADE
    val ADDRESS_SUITE_MAX_LEN: Long = 50 // N_SUITE
    val ADDRESS_POST_OFFICE_BOX_MAX_LEN: Long = 50 // X_APARTADO
    val ADDRESS_DISTRICT_MAX_LEN: Long = 100 // N_DISTRITO
    val ADDRESS_COUNTRY_SUB_ENTITY_MAX_LEN: Long = 100 // N_SUB_ENTIDADE_DO_PAIS
    val ADDRESS_OTHER_LOCAL_ID_MAX_LEN: Long = 100 // N_OUTRO_IDENTIFICADOR_LOCAL

    // Websites
    val WEBSITE_MIN_LEN: Long = 1
    val WEBSITE_MAX_LEN: Long = 250 // From data model

    // ContactName
    // Single value fields
    val CONTACT_NAME_FREE_TEXT_MAX_LEN: Long = 160 // N_NOME_LIVRE_CONTACTO
    val CONTACT_NAME_PRECEDING_TITLE_MAX_LEN: Long = 100 // N_TITULO_PRECEDENTE_CONTACTO
    val CONTACT_NAME_FIRST_NAME_MAX_LEN: Long = 100 // N_PRIMEIRO_NOME_CONTACTO
    val CONTACT_NAME_LAST_NAME_PREFIX_MAX_LEN: Long = 100 // N_PREFIXO_CONTACTO
    val CONTACT_NAME_LAST_NAME_MAX_LEN: Long = 100 // N_ULTIMO_NOME_CONTACTO
    val CONTACT_NAME_GENERAL_SUFFIX_MAX_LEN: Long = 100 // N_SUFIXO_GERAL_CONTACTO
    val CONTACT_NAME_MAIDEN_NAME_MAX_LEN: Long = 100 // N_NOME_SOLTEIRA_CONTACTO
    // Multiple value fields
    val CONTACT_NAME_TITLE_MAX_LEN: Long = 250 // OST_INF_ADIC_REG0__N_INF_ADIC_REG
    val CONTACT_NAME_MIDDLE_NAME_MAX_LEN: Long = 250 // OST_INF_ADIC_REG0__N_INF_ADIC_REG
    val CONTACT_NAME_GEN_IDENTIFIER_MAX_LEN: Long = 250 // OST_INF_ADIC_REG0__N_INF_ADIC_REG
    val CONTACT_NAME_SUFFIX_MAX_LEN: Long = 250 // OST_INF_ADIC_REG0__N_INF_ADIC_REG

    // ContactInfo
    val CONTACT_INFO_EMAIL_MAX_LEN: Long = 64 // X_EMAIL
    val CONTACT_INFO_TELEPHONE_MAX_LEN: Long = 20 // X_TELEFONE(50) | ECOM-OSS-TS-v2.03 Table 11 (20)

    // BankAccountInfo
    val BANK_ACCOUNT_OWNER_MAX_LEN: Long = 70 // ECOM-OSS-FS-v2.02 Table 120 - GEN-RU-ACCOUNT-NAME
    val BANK_ACCOUNT_IBAN_MAX_LEN: Long = 34 // ECOM-OSS-FS-v2.02 Table 120 - GEN-RU-IBAN-STRUCT
    val BANK_ACCOUNT_OBAN_MAX_LEN: Long = 100 // OSS_REGISTO_OSS0__X_OBAN_NETP
    val BANK_ACCOUNT_BIC_MAX_LEN: Long = 11 // ECOM-OSS-FS-v2.02 Table 120 - GEN-RU-BIC-STRUCT

    // Fixed Establishments
    val FIXED_ESTAB_TRADING_NAME_MIN_LEN: Long = 1
    val FIXED_ESTAB_TRADING_NAME_MAX_LEN: Long = 160 // OST_ESTABELECIMENTO_ESTAVEL0__N_DENOMINACAO
}
